<template>
  <div class="wrapper-page">
    <div class="container-fluid">
      <div>
        <h1 class="page-title">
          {{ `${documentType.name}, ${recordsCount}` }} {{ $t('document_types.show.file_name') }}
        </h1>
      </div>

      <div class="clearfix"></div>
      <div class="btn-group float-right show-hide-columns" role="group" v-click-outside="closeDropdown">
        <button class="btn btn-neutral dropdown-toggle" v-on:click="openDropdown = !openDropdown">
          {{$t('contacts.show_hide_columns')}}
        </button>

        <ul class="dropdown-menu" v-if="openDropdown">
          <li class="dropdown-item" @click="toggleColumns('files')">
            <input type="checkbox" :checked="showFiles" />
            {{ $t('document_types.show.file_name') }}
          </li>
          <li class="dropdown-item" @click="toggleColumns('contact')">
            <input type="checkbox" :checked="showContact" />
            {{ $t('document_types.show.contact_name') }}
          </li>
          <li class="dropdown-item" @click="toggleColumns('created')">
            <input type="checkbox" :checked="showCreated" />
            {{ $t('document_types.show.created_at') }}
          </li>
          <li>
            <button class="btn btn-primary float-right m-r-10" v-on:click="openDropdown = false">
              {{$t('contacts.edit_modal.save')}}
            </button>
          </li>
        </ul>
      </div>
      <loading v-if="loading" />
      <table class="table" v-else>
        <thead>
          <tr>
            <th v-if="showFiles">{{ $t('document_types.show.file_name') }}</th>
            <th v-if="showContact">{{ $t('document_types.show.contact_name') }}</th>
            <th v-if="showCreated">{{ $t('document_types.show.created_at') }}</th>
          </tr>
        </thead>
        <tbody name="fade" is="transition-group" v-if="recordsCount > 0">
          <tr v-for='record in records' :key="record.id">
            <td v-if="showFiles">
              <router-link :to="{name: 'record', params: { id: record.id }}">
                {{ record.filename }}
              </router-link>
            </td>
            <td v-if="showContact">
              <router-link :to="{name: 'record', params: { id: record.id }}">
                {{ record.contact_name }}
              </router-link>

            </td>
            <router-link :to="{name: 'record', params: { id: record.id }}">
              <td v-if="showCreated">{{ formatDate(record.created_at)}}</td>
            </router-link>
          </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td>
            {{ $t('document_types.show.no_files') }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import _loading from '../components/_loading'
  export default {
    components: {
      'loading': _loading
    },
    created() {
      this.loading = true
      this.store.getDocumentType(this.documentTypeId)
      this.statStore.getDocumentTypes({ 'filters[id]': this.documentTypeId }).then(() => {
        this.loading = false
      })
      this.store.sendMetrics({name: 'document_type', params: this.$route.params, path: this.$route.fullPath})
    },
    data() {
      return {
        openDropdown: false,
        loading: true
      }
    },
    computed: {
      documentTypeId() {
        return this.$route.params.id
      },
      documentType() {
        return this.state.documentType || {}
      },
      statDocumentType() {
        if (!this.stats.documentTypes)
          return {}

        return this.stats.documentTypes.find(d => d.id == this.documentTypeId) || {}
      },
      records() {
        return this.statDocumentType.records || []
      },
      recordsCount() {
        return this.records.length
      },
      documentTypeShowColumns() {
        return new Set((this.userDefaults.document_type_show || []))
      },
      showFiles() {
        return this.documentTypeShowColumns.has('files')
      },
      showContact() {
        return this.documentTypeShowColumns.has('contact')
      },
      showCreated() {
        return this.documentTypeShowColumns.has('created')
      },
    },
    methods: {
      closeDropdown() {
        this.openDropdown = false
      },
      toggleColumns(column) {
        const newDocumentTypeShowColumns = this.documentTypeShowColumns

        this.documentTypeShowColumns.has(column) ? newDocumentTypeShowColumns.delete(column) : newDocumentTypeShowColumns.add(column)

        const newDefaults = Object.assign({}, this.currentUser.defaults, { document_type_show: Array.from(newDocumentTypeShowColumns) })

        this.store.updateUserProfile({ user: { defaults: newDefaults } }).then(() => {
            this.store.getCurrentUser()
        })
      },
    }
  }
</script>
<style lang="sass" scoped>
  .clear
    clear: both
</style>
